export default (number: number): string => {
  // Return the number formatted with a leading 0 (ensures the number will always have 2 digits)
  if (number < 10) {
    return `0${number}`;
  }
  return String(number);
};
